const Datacenter = () => import('../views/DataManage/datacenter/index.vue');
export default [
  {
    path: '/datacenter',
    name: '数据中心',
    component: Datacenter,
    meta: [{ name: '数据中心' }],
  },
];